__turbopack_context__.v({
  "activeDot": "cardGroup-module-scss-module__QREK3q__activeDot",
  "cardImages": "cardGroup-module-scss-module__QREK3q__cardImages",
  "cardImgWrapper": "cardGroup-module-scss-module__QREK3q__cardImgWrapper",
  "counter": "cardGroup-module-scss-module__QREK3q__counter",
  "dot": "cardGroup-module-scss-module__QREK3q__dot",
  "dots": "cardGroup-module-scss-module__QREK3q__dots",
});
